import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import Checkbox from './Checkbox/Checkbox';
import FareConditionsModal from '../../FareConditions/components/Component';

import { useTheme } from '../../theme';

import { isCheckoutOrderGuard } from '../../typeguards';

import { useConsents } from './Consents.hook';

export interface Props {
	disableTermsOfTariff?: boolean;
	children: (model: ReturnType<typeof useConsents>) => React.ReactNode;
}

const Consents: React.FC<Props> = ({ children, disableTermsOfTariff = false }) => {
	const { t } = useTranslation('Consents');
	const { Consents: theme } = useTheme('Consents');

	const model = useConsents();

	const orderId = model.order.id;

	// this is done in order to prevent an error.
	// won't work correctly with CheckinOrderFragment
	const flightId = isCheckoutOrderGuard(model.order) ? model.order.flight.id : null;
	const segmentId = isCheckoutOrderGuard(model.order) ? model.order.flight.segments[0].segment.id : null;

	const tooltipLabel = t('Checkout:Please, read the rules of service and accept it');

	return (
		<>
			{(model.isNeedToShowRules || model.isNeedToShowTransferRules) && (
				<div
					className={cn(theme.container, { [theme.disableTermsOfTariff]: disableTermsOfTariff })}
					onClick={model.onClick}
				>
					{model.isNeedToShowRules && (
						<div className={theme.consent}>
							<Checkbox
								label={model.rules}
								tooltipLabel={tooltipLabel}
								isChecked={model.commonConsentsCheckbox.isChecked}
								isTooltipOpen={model.commonConsentsCheckbox.isTooltipOpen}
								onChange={model.commonConsentsCheckbox.onChange}
								ref={model.commonConsentsCheckbox.checkboxRef}
							/>
						</div>
					)}

					{model.isNeedToShowTransferRules && (
						<div className={theme.consent}>
							<Checkbox
								label={model.transferRules}
								tooltipLabel={tooltipLabel}
								isChecked={model.transferConsentsCheckbox.isChecked}
								isTooltipOpen={model.transferConsentsCheckbox.isTooltipOpen}
								onChange={model.transferConsentsCheckbox.onChange}
								ref={model.transferConsentsCheckbox.checkboxRef}
							/>
						</div>
					)}
				</div>
			)}

			{children(model)}

			{model.order && (
				<FareConditionsModal
					segmentId={segmentId}
					flightId={flightId}
					orderId={orderId}
					isOpen={model.isFareModalOpen}
					onClose={model.closeFareModal}
				/>
			)}
		</>
	);
};

export default Consents;
